import { useHistory } from 'react-router';
import { ArrowIcon, Button } from '@cmsgov/ds-medicare-gov';
import React from 'react';
import translate from '../functions/translate';

const BackNav = () => {
    const history = useHistory();
    return (
        <nav
            aria-label={translate('back')}
            className="my-c-breadcrumb ds-u-visibility--hidden-print"
            style={{
                height: "65px",
                borderBottom: "1px solid #d9d9d9",
                display: "flex",
                alignItems: "center",
            }}
        >
            <div className="ds-l-container my-u-width--full" style={{ width: "100%" }}>
                <div className="ds-l-row ds-u-justify-content--center">
                    <div className="ds-l-col--12">
                        <Button
                            variation='ghost'
                            onClick={() => { history.goBack(); }}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                paddingLeft: "0",
                                textDecoration: "none"
                            }}
                        >
                            <ArrowIcon direction='left' />
                            <span style={{ marginLeft: "6px" }}>{translate('back')}</span>
                        </Button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default BackNav;